export default __webpack_public_path__ + "static/media/coresanscr95-webfont.c08df5fb.woff2";